import { render } from "./base-router-view.vue?vue&type=template&id=1b2e85d2&ts=true"
import script from "./base-router-view.vue?vue&type=script&lang=ts"
export * from "./base-router-view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__